import * as React from 'react';
import { RoundButtonType } from './RoundButtonType';
import Button from '@mui/material/Button';
import { useHistory, useLocation } from 'react-router-dom';
import './button.css';
import Box from '@mui/material/Box';

function RoundButton(props: RoundButtonType) {
  const location = useLocation();
  const { title, onClick, type, disable } = props;
  const onClickButton = () => {
    if (onClick) return onClick();
  };
  return (
    <Box className='roundButtonBox' style={{ textAlign: 'center' }}>
      <Button
        variant='contained'
        type={type ? type : 'button'}
        className={location.pathname === '/' ||
        location.pathname === '/p2p/verifyOtp' ||
        location.pathname === '/p2p/personalInfo' ||
        location.pathname === '/p2p/personalInfoSecond' ||
        location.pathname === '/p2p/connectBank' ||
        location.pathname === '/p2p/lenderAgreement'
        ? 'round-button' : 'round-button radius-15'}
        onClick={() => onClickButton()}
        disabled={disable}
      >
        {title}
      </Button>
    </Box>
  );
}

export default RoundButton;
